// extracted by mini-css-extract-plugin
export default {"link":"DetailedTermsAndConditions-module__link__af43v","container":"DetailedTermsAndConditions-module__container__bSESi"};